module.exports = __webpack_public_path__ + "static/media/logo-remente.578c5cd2.svg";